import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { CommonFilters, TitleHeader } from "../../../components";
import usePagesList from "./pagesUtils";
import CommonTable from "../../../common/commonTable";
import { useNavigate } from "react-router-dom";

const columns = [
  { label: "Title", key: "page_title" },
  { label: "Status", key: "status" },
];

const PagesList = () => {
  const navigate = useNavigate();
  const {
    listData,
    loading,
    langauges
  } = usePagesList();

  const actions = (item) => [
    {
      title: "Edit",
      icon: <EditIcon />,
      action: () => navigate(`/page/edit/${item.page_id}`),
    },
  ];

  const formattedData = (listData?.docs || []).map((item) => ({
    ...item,
    ...(item.page_descriptions || {}),
    // title: item.page_descriptions?.title || "N/A",
    // description: item.page_descriptions?.description || "N/A",
  }));

  console.log(formattedData);

  return (
    <>
      <TitleHeader
        heading="Welcome to Jayeek!  "
        buttonText="+ Add New"
        
      />
      <div className="page-card-bg table-data-new">
        <CommonFilters
          heading="Page List"
         
        />

        <CommonTable
          columns={columns}
          data={formattedData}
          actions={actions}
          loading={loading}
        />
      </div>
    </>
  );
};

export default PagesList;
